import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailAtfVariantRevamp from "./component";

const mapStateToProps = ({
    carDetails: {
        galleryProps: { isOpen: isGalleryOpen },
        content
    },
    abExperiment: {
        showCdpGalleryVariant
    },
    checkout: {
        order
    },
    config: {
        testDriveConfig
    }
}) => ({
    isGalleryOpen,
    content,
    showCdpGalleryVariant,
    order,
    testDriveConfig
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CarDetailAtfVariantRevamp);
